import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import { get_Date } from "../../Utils/commonFunctions";
import {
  getSurveyAnalysisPreview,
  deleteAnalysisGraph,
} from "../../Utils/adminFunctions";
import {
  AdminQuestionOption,
  AdminAnalysisGraph,
  AdminTextResponces,
} from "./AdminCommanComponent";
import { Bar } from "react-chartjs-2";

import AdminAnalysisDownload from "./AdminAnalysisDownload";

const AdminAnalysisPreview = () => {
  const [questionData, setQuestiondata] = useState("");
  const [chartQuestion, setChartQuestion] = useState("");
  const [questionType, setQuestionType] = useState("");
  const [isChart, setIsChart] = useState(0);
  const [colors, setColors] = useState([]);
  const [reportsChartsData, setReportsChartsData] = useState("");
  const [options, setOptions] = useState("");
  const [textResponse, setTextResponse] = useState("");
  const [tmpDeleteID, setTmpDeleteID] = useState("");
  const [title, setTitle] = useState("");
  const [tmpPopupchartData, setTmpPopupchartData] = useState([]);
  const { surveyID, questionID, questionNo } = useParams();
  const labels = [""];
  const optionsChart = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: title,
        padding: {
          top: 10,
          bottom: 10,
        },
        color: "#0069d9",
      },
      scales: {
        xaxis: {
          beginAtZero: true,
          ticks: {
            stepSize: 1.0,
          },
        },
      },
    },
  };
  useEffect(() => {
    AdminSurveyAnalysisPreview();
  }, []);
  const AdminSurveyAnalysisPreview = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append("survey_id", surveyID);
    bodyFormData.append("question_id", questionID);
    bodyFormData.append("question_no", questionNo);
    const response = await getSurveyAnalysisPreview(bodyFormData);
    if (response.status === "success") {
      setQuestiondata(response.data);
      setColors(response.data.COLOR);
      if (Object.keys(response.data.reportscharts).length === 0) {
        setIsChart(0);
        setReportsChartsData("");
      } else {
        setIsChart(1);
        let tempChartData = response.data.reportscharts.map((item, i) => {
          return (
            <div className="col-md-6 mb-4 d-flex align-items-stretch">
              <AdminAnalysisGraph
                reportsCharts={item}
                key={i}
                handleDelete={handleDelete}
                handlePopup={handlePopup}
              />
            </div>
          );
        });
        setReportsChartsData(tempChartData);
      }
      if (response.data.chartquestion.options === "") {
        setOptions("");
      } else {
        setOptions(response.data.chartquestion.options);
      }
      if (Object.keys(response.data.textresponse).length === 0) {
        setTextResponse("");
      } else {
        let tempTextResponcesData1 = response.data.textresponse.map(
          (item, i) => {
            return (
              <AdminTextResponces
                label={item.label}
                key={i}
                key1={i}
                textResponseItem={item.textresponseitem}
              />
            );
          }
        );
        setTextResponse(tempTextResponcesData1);
      }
      setChartQuestion(response.data.chartquestion);
      setQuestionType(response.data.chartquestion.type);
    } else {
      toast.error(response, { autoClose: 1500 });
    }
  };
  let handlePopup = (title, data) => {
    setTitle(title);
    setTmpPopupchartData(data);
  };
  const handleDelete = (analysisID) => {
    setTmpDeleteID(analysisID);
  };
  const handleAdminAnalysisDelete = async () => {
    const response = await deleteAnalysisGraph(surveyID, tmpDeleteID);
    if (response.status === "success") {
      toast.success(response.message, { autoClose: 1500 });
      document.getElementById("modal-default").click();
      AdminSurveyAnalysisPreview();
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };

  return (
    <div>
      <ToastContainer></ToastContainer>
      <div className="modal fade show" id="modal-chart" arial-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <Bar
                options={optionsChart}
                data={{
                  labels,
                  datasets: tmpPopupchartData,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade show" id="modal-default" arial-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Confirm delete</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this record?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-sm btn-dark"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => handleAdminAnalysisDelete()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="wrapper">
        <div>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12 mb-2">
                    <h3 className="card-title">
                      <AdminAnalysisDownload></AdminAnalysisDownload>
                    </h3>
                    <h3 className="card-title pull-right ">
                      <Link
                        to={"/AdminCreateAnalysis/" + surveyID}
                        className="btn btn-sm custom-btn-primary"
                      >
                        <i className="fa fa-arrow-left"></i> Back
                      </Link>
                    </h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-12" id="page">
                            <table className="analysis-preview-table table-bordered">
                              <tbody>
                                <tr>
                                  <td>No. of responses/Total Participants</td>
                                  <td>
                                    {questionData.no_of_paticipants}/
                                    {questionData.no_of_responses}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Launch Date</td>
                                  <td>{get_Date(questionData.launch_date)}</td>
                                </tr>
                                <tr>
                                  <td>Completion Date</td>
                                  <td>
                                    {get_Date(questionData.completion_date)}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="sar-question">
                              <div className="sar-question-number">
                                {questionData.question_no}
                              </div>
                              <span className="sar-question-text">
                                {chartQuestion.label}
                                {chartQuestion.type === "survey"
                                  ? " > " + chartQuestion.survey_label
                                  : ""}
                              </span>
                            </div>
                            {(chartQuestion.type === "radio" ||
                              chartQuestion.type === "selectboxes" ||
                              chartQuestion.type === "survey") && (
                              <AdminQuestionOption
                                questionType={questionType}
                                isChart={isChart}
                                options={options}
                                colors={colors}
                              />
                            )}
                          </div>
                          {reportsChartsData != "" && reportsChartsData}
                          {textResponse && (
                            <div className="row">
                              <div className="col-md-12 text-left">
                                <h6 className="p-0">
                                  <strong>Text response</strong>
                                </h6>
                              </div>
                              {textResponse}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminAnalysisPreview;
